import React, { useEffect, useState } from "react";
import styles from "../QuickBuyComp/QuickBuyComp.module.scss";
import PLPSwatches from "../common/PLPSwatches";
import { addToBag, pushAddToCartEvent, pushCartUpdateEvent } from "@/helpers/cartEventHelper";
import { useSelector } from "react-redux";
import { setCart } from "../common/Nosto";
import { addToCart, openMiniCart,openQBMiniCart } from "@/redux/actions/addToCartAction";
import { useDispatch } from "react-redux";
import { getVariantPrice } from "@/helpers/pdpHelpers/priceHelpers";
import PLPMobileSwatches from "../common/PLPMobileSwatches";
import QuickBuyIcon from "@/components/Logos/QuickBuy";
import {algoliaConversionTracking} from "@/helpers/productHelper"
import { setScrollPos } from "@/redux/actions/drawerAction";
export default function QuickBuyComp(props) {
  {
    if(!props.pdp_view) {
      if(props.product_handle != props.qb_array.handle) {
        props.setGenerateQuickBuy(true)
      } else {
        props.setGenerateQuickBuy(false)
      }
    }
    const cart_list = useSelector((state) => state.click.cart_list);
    const [clicked, setOnclick] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    let logUser = useSelector((state) => state.loginUser);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    useEffect(()=>{ 
      if(clicked){
        var data = props.productDetails;
  
        if(data){
          pushAddToCartEvent(data,props.selectedVariant,logUser,props.link,'Quick Buy Add to Cart');
          setOnclick(false)
        }
      } 
     
      if(cart_list?.lineItems?.edges?.length){
        pushCartUpdateEvent(cart_list);
      }    
    },[cart_list])
    const setQuickByClicked = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setShowOptions(true)
      if(props.qb_array.singleVariant) {
      props.setQuickBuyClicked(true)
      }
    };
    const performAddToCart = async () => {
      setLoading(true);
      let price,
      salePrice;
      //only send the conversion event if object id is present
      //This is done to prevent tracking from from anywhere else expect PLP
      const quickbuy = true; //to pass that the value is coming from quickbuy
      if(props.objectID){
        algoliaConversionTracking(props.objectID,props.queryID,quickbuy);
      }
      let priceObj = getVariantPrice(props.selectedVariant, props.productDetails.productType);
      if (priceObj.returnedPrice) {
        price = priceObj.returnedPrice;
      }
      if (priceObj.returnedSalePrice) {
        salePrice = priceObj.returnedSalePrice;
      }
      let finalProductPrice = salePrice ? salePrice : price;
      let gaPrice = finalProductPrice.replace(/\,/g,'');
      props.productDetails.price = parseFloat(gaPrice.substring(1));
      let response = await addToBag(props.selectedVariant, props.badge_curated, props.productDetails, {"device":props.device});
      await setCart(response);
      dispatch(addToCart(response));
      dispatch(setScrollPos(window.scrollY))
      dispatch(openMiniCart(true));
      dispatch(openQBMiniCart(true));
      if(props.searchComp) {	
        document.querySelector("body").classList.add("v-main-none");	
      }
      setTimeout(() => {	
        document.querySelector(".search_wrapper").classList.add("shift_back");	
      }, 200);	
      setTimeout(() => {
        dispatch(openMiniCart(false));
        dispatch(openQBMiniCart(false));
        document.querySelector(".search_wrapper").classList.remove("shift_back");
        document.querySelector("body").classList.remove("v-main-none");
      }, 5000);
      setLoading(false);
      props.setQuickBuyClicked(false)  
      setShowOptions(false)
    };
    useEffect(()=>{
      if(props.quickBuyClicked && props.selectedVariant) {
        performAddToCart();
        setOnclick(true);
      }
    }, [props.quickBuyClicked]);
      return (       
        <>       
          <div tabIndex={0} className={`quick_buy dark ${styles.quick_buy} ${props.qb_array.singleVariant == true ? 'hide-options' : ''} ${props.searchComp ? styles.qb_small : ''} ${props.qb_array.singleVariant != true && showOptions ? styles.opened : ''}`} onMouseLeave={() => setShowOptions(false)} onMouseEnter={() => setShowOptions(true)} onClick={setQuickByClicked} >
          <QuickBuyIcon width="100%" height="100%" stroke="#2f2f30" fill="none" className={`${styles.quick_buy_icons} d-xs-none ${props.qb_array.singleVariant == true ? props.bundleQuickBuy ? "ga-bundle-quick-buy": "" : ""}`}/>
              {
              props.qb_array.showQuickBuy && props.qb_array && props.qb_array.colors && props.qb_array.colors.length > 1 &&
              <PLPSwatches
              data={props.qb_array.colors}
              hexCodeArray={props.qb_array.hexCodeArray}
              selected={props.selectedColor}
              setSelected={props.setSelectedColor}
              type="color"
              id="colorPicker"
              handle={props.handle}
              quickBuyClicked={props.quickBuyClicked}
              setQuickBuyClicked={props.setQuickBuyClicked}
              link={props.link}
              loading={loading}
              showOptions={showOptions}
              searchPopupEnabled={props.searchComp}
              bundleQuickBuy={props.bundleQuickBuy}
              variantMap={props.qb_array.variantMap}
            />
              }

              {props.qb_array.showQuickBuy && props.qb_array && props.qb_array.letters && props.qb_array.letters.length > 1 &&
              <PLPSwatches
              data={props.qb_array.letters}
              selected={props.selectedLetter}
              setSelected={props.setSelectedLetter}
              type="letter"
              id="letterPicker"
              handle={props.handle}
              quickBuyClicked={props.quickBuyClicked}
              setQuickBuyClicked={props.setQuickBuyClicked}
              link={props.link}
              loading={loading}
              showOptions={showOptions}
              searchPopupEnabled={props.searchComp}
              bundleQuickBuy={props.bundleQuickBuy}
              variantMap={props.qb_array.variantMap}
            />}

              {props.qb_array.showQuickBuy && (props.qb_array.showSize || props.qb_array.sizes.length > 1) && props.qb_array && props.qb_array.sizes &&
              <PLPSwatches
              data={props.qb_array.sizes}
              selected={props.selectedSize}
              setSelected={props.setSelectedSize}
              type="sizes"
              id="sizePicker"
              handle={props.handle}
              quickBuyClicked={props.quickBuyClicked}
              setQuickBuyClicked={props.setQuickBuyClicked}
              link={props.link}
              loading={loading}
              showOptions={showOptions}
              searchPopupEnabled={props.searchComp}
              bundleQuickBuy={props.bundleQuickBuy}
              variantMap={props.qb_array.variantMap}
            />}
          </div>
          {/* {props.isOnlyMobile && <div className={`quick_buy dark ${styles.quick_buy} hide-options ${showOptions?styles.qb_open:""}`} onClick={setQuickByClicked}>
            {props.qb_array.singleVariant && <QuickBuyIcon stroke="#2f2f30" fill="none" className={`${styles.quick_buy_icons} ${styles.single_variant} ${props.bundleQuickBuy ? "ga-bundle-quick-buy": ""}`}/>}
          { props.qb_array.showQuickBuy && props.qb_array && props.qb_array.colors && props.qb_array.colors.length > 1 &&
              <PLPMobileSwatches
          data={props.qb_array.colors}
          hexCodeArray={props.qb_array.hexCodeArray}
          selected={props.selectedColor}
          setSelected={props.setSelectedColor}
          type="color"
          id="colorPickerMobile"
          handle={props.handle}
          quickBuyClicked={props.quickBuyClicked}
          setQuickBuyClicked={props.setQuickBuyClicked}
          link={props.link}
          productDetails={props.productDetails}
          dropdownTitle="color"
          loading={loading}
          setLoading={setLoading}
          productImage={props.productImage}
          buttonCTAText="Choose your color"
          showOptions={showOptions}
          setShowOptions={setShowOptions}
          bundleQuickBuy={props.bundleQuickBuy}
        />
              }

              {props.qb_array.showQuickBuy && props.qb_array && props.qb_array.letters && props.qb_array.letters.length > 1 &&
              <PLPMobileSwatches
              data={props.qb_array.letters}
              selected={props.selectedLetter}
              setSelected={props.setSelectedLetter}
              type="letter"
              id="letterPickerMobile"
              handle={props.handle}
              quickBuyClicked={props.quickBuyClicked}
              setQuickBuyClicked={props.setQuickBuyClicked}
              link={props.link}
              productDetails={props.productDetails}
              dropdownTitle="letter"
              loading={loading}
              setLoading={setLoading}
              productImage={props.productImage}
              buttonCTAText="Choose your letter"
              showOptions={showOptions}
              setShowOptions={setShowOptions} 
              bundleQuickBuy={props.bundleQuickBuy}
            />}

              {props.qb_array.showQuickBuy && props.qb_array && props.qb_array.sizes && (props.qb_array.showSize || props.qb_array.sizes.length > 1) &&
              <PLPMobileSwatches
              data={props.qb_array.sizes}
              selected={props.selectedSize}
              setSelected={props.setSelectedSize}
              type="sizes"
              id="sizePickerMobile"
              handle={props.handle}
              quickBuyClicked={props.quickBuyClicked}
              setQuickBuyClicked={props.setQuickBuyClicked}
              link={props.link}
              productDetails={props.productDetails}
              dropdownTitle="size"
              loading={loading}
              setLoading={setLoading}
              productImage={props.productImage}
              buttonCTAText="Choose your size"
              showOptions={showOptions}
              setShowOptions={setShowOptions}
              bundleQuickBuy={props.bundleQuickBuy}
            />}
            </div>} */}
        </>
      );
  }
}
